// TaskSubjectAvatar — a task row's leading avatar: the member's avatar when the
// task is about a person, else the resource/app logo. Shared by the Home Tasks
// card and the Tasks page so the two can't drift.

import AppLogo from "components/ds/AppLogo";
import Avatar from "components/ds/Avatar";
import type { MFTaskItem } from "state/members/tasks";

const TaskSubjectAvatar = ({ task }: { task: MFTaskItem }) =>
  task.memberName ? (
    <Avatar name={task.memberName} src={task.memberImageUrl ?? undefined} size="sm" ring />
  ) : (
    <AppLogo name={task.title} logoUrl={task.resourceImageUrl ?? undefined} size="sm" />
  );

export default TaskSubjectAvatar;
